import { takeLatest } from 'redux-saga/effects';
import { taskCollection, updateTaskRecord } from 'collections/tasks';
import { updateDocTask } from 'data/documents';
function* updateDocTaskManager(action) {
    const { payload } = action;
    const { projectId, taskId, partialTask, options } = payload;
    try {
        const response = yield updateTaskRecord(projectId, taskId, partialTask);
        if (options === null || options === void 0 ? void 0 : options.resolveCallback) {
            options.resolveCallback(response);
        }
        taskCollection.push([
            response
        ]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
    // TODO: handle error
    }
}
export const watchUpdateDocTasks = function*() {
    yield takeLatest(updateDocTask.type, updateDocTaskManager);
};
